// Pełny program kursu - 100 pytań, 5 modułów.
// UWAGA: treść nie może być zmieniana, skracana ani parafrazowana.

export const MODULES = [
    {
        id: 1,
        name: "Dynamika grupy i zachowanie uczniów",
        range: "Lekcje 1–18",
        desc: "Jak reagować, gdy ktoś dominuje, milczy albo zakłóca rozmowę.",
        topics: [
            "Mam w grupie ucznia, który mówi bez przerwy i nie daje dojść do głosu innym – jak poradzić sobie z tym problemem?",
            "Dorosły uczeń ciągle przeprasza za swój angielski: „Sorry, my English is terrible”. Jak na to reagować?",
            "Mam dorosłego ucznia, który mówi: „Ja tego nigdy nie zapamiętam”. Jak pracować z brakiem wiary we własne możliwości?",
            "Mam ucznia, który ciągle wchodzi w słowo innym – jak reagować?",
            "Mam uczniów, którzy odpowiadają tylko jednym zdaniem – jak ich rozgadać?",
            "Mam dorosłych uczniów, którzy oczekują, że wszystko wyjaśnię po polsku. Jak pracować bez ciągłego tłumaczenia?",
            "Mam ucznia, który ciągle zmienia temat rozmowy – jak utrzymać strukturę lekcji?",
            "Mam uczniów, którzy nie chcą brać udziału w aktywnościach – jak ich zaangażować?",
            "Mam ucznia, który żartuje z innych uczestników – jak reagować?",
            "Mam ucznia, który narzeka na poziom zajęć – jak to rozwiązać?",
            "Mam ucznia, który ciągle zadaje pytania niezwiązane z tematem – co zrobić?",
            "Mam ucznia, który chce mówić tylko o sobie – jak poszerzyć rozmowę?",
            "Mam uczniów, którzy unikają trudniejszych tematów – jak ich zachęcić do dyskusji?",
            "Mam ucznia, który zniechęca innych mówiąc, że coś jest trudne – jak reagować?",
            "Mam grupę, która jest bardzo cicha i trudno ją rozruszać – jak ją ożywić?",
            "Mam ucznia, który ciągle mówi: „Nie wiem” – jak wyjść z tej sytuacji?",
            "Mam uczniów, którzy nie reagują na pytania otwarte – jak je zadawać inaczej?",
            "Mam uczniów, którzy unikają kontaktu wzrokowego i rozmowy – jak ich włączyć?",
        ],
    },
    {
        id: 2,
        name: "Motywacja dorosłych uczniów",
        range: "Lekcje 19–38",
        desc: "Co zrobić, gdy spada zaangażowanie albo pojawia się zniechęcenie.",
        topics: [
            "Mam ucznia, który mówi: „Ja chcę tylko rozmawiać” - jak prowadzić takie zajęcia?",
            "Mam ucznia, który mówi, że nie ma czasu na naukę między lekcjami - co zrobić?",
            "Mam ucznia, który mówi: „Ja nigdy nie nauczę się języka” - jak reagować?",
            "Mam ucznia, który uważa, że jest za stary na naukę języka - jak zmienić jego podejście?",
            "Mam ucznia, który szybko się zniechęca - jak go zmotywować?",
            "Mam uczniów, którzy nie odrabiają pracy domowej - jak reagować?",
            "Mam ucznia, który oczekuje bardzo szybkich efektów - jak ustawić realistyczne oczekiwania?",
            "Mam ucznia, który mówi, że nauka języka jest dla niego stresująca - jak zmniejszyć ten stres?",
            "Mam ucznia, który porównuje się z innymi i traci motywację - jak mu pomóc?",
            "Mam uczniów, którzy tracą motywację w połowie kursu - jak temu zapobiec?",
            "Mam ucznia, który mówi, że nie pamięta tego, czego się nauczył - jak mu pomóc?",
            "Mam ucznia, który nie widzi swoich postępów - jak mu je pokazać?",
            "Mam ucznia, który boi się mówić z powodu błędów - jak go przełamać?",
            "Mam ucznia, który mówi, że potrzebuje języka tylko do pracy - jak prowadzić takie zajęcia?",
            "Mam ucznia, który nie widzi sensu w ćwiczeniach - jak je uzasadniać?",
            "Mam ucznia, który ciągle pyta „po co nam to?” - jak odpowiadać?",
            "Mam ucznia, który chce tylko konkretów i nie lubi rozmów - jak pracować?",
            "Mam ucznia, który szybko się nudzi na lekcji - jak utrzymać jego uwagę?",
            "Mam ucznia, który jest perfekcjonistą i boi się mówić - jak mu pomóc?",
            "Mam ucznia, który ciągle mówi, że zapomina słownictwo - jak temu zaradzić?",
        ],
    },
    {
        id: 3,
        name: "Prowadzenie lekcji i rozmowy",
        range: "Lekcje 39–58",
        desc: "Jak uruchomić, podtrzymać i dobrze zakończyć rozmowę na lekcji.",
        topics: [
            "Mam lekcję konwersacyjną i nie wiem, jak ją dobrze rozpocząć - co zrobić?",
            "Mam temat rozmowy, ale uczniowie szybko go wyczerpują - jak go rozwinąć?",
            "Mam lekcję konwersacyjną i rozmowa nie chce się rozkręcić - jak ją uruchomić?",
            "Mam lekcję 1-1 i trudno mi utrzymać rozmowę przez godzinę - jak to zrobić?",
            "Mam lekcję grupową i trudno mi wciągnąć wszystkich do rozmowy - jak to zmienić?",
            "Mam ucznia, który mówi bardzo wolno - jak pracować z takim tempem?",
            "Mam ucznia, który mówi bardzo dużo - jak zarządzać czasem wypowiedzi?",
            "Mam uczniów, którzy odpowiadają bardzo krótko - jak wydłużyć ich wypowiedzi?",
            "Mam lekcję konwersacyjną i kończą mi się pytania - co zrobić?",
            "Mam lekcję i czuję, że rozmowa zamienia się w przesłuchanie - jak tego uniknąć?",
            "Mam uczniów, którzy mówią tylko wtedy, gdy ich wywołam - jak to zmienić?",
            "Mam uczniów, którzy nie reagują na tematy dyskusyjne - jak je wprowadzać?",
            "Mam lekcję, na której energia szybko spada - jak ją podnieść?",
            "Mam lekcję, na której temat nie interesuje uczniów - jak to zmienić?",
            "Mam aktywność, która nie działa tak jak planowałam - jak reagować?",
            "Mam lekcję i widzę, że uczniowie są zmęczeni po pracy - jak ją prowadzić?",
            "Moi uczniowie boją się używania trudniejszych wyrazów i struktur. Jak zmotywować ich do większej odwagi w używaniu języka?",
            "Mam lekcję i nie wiem, jak ją dobrze zakończyć - jak to zrobić?",
            "Ciągle mówię uczniom „Good job!”, ale mam wrażenie, że taki feedback niewiele im daje. Co mówić zamiast tego?",
            "Mam lekcję i nie wiem, jak zrobić dobre podsumowanie - jak je poprowadzić?",
        ],
    },
    {
        id: 4,
        name: "Poziom uczniów i trudność materiałów",
        range: "Lekcje 59–78",
        desc: "Jak pracować z grupami mieszanymi i dobierać materiał do ucznia.",
        topics: [
            "Mam grupę, w której uczniowie są na różnych poziomach - jak prowadzić lekcję?",
            "Mam ucznia dużo lepszego od reszty grupy - jak go zaangażować?",
            "Mam ucznia dużo słabszego od reszty - jak mu pomóc?",
            "Mam grupę, w której uczniowie uczą się w różnym tempie - jak to pogodzić?",
            "Mam grupę A2-B2 - jak zaplanować lekcję dla takiego poziomu?",
            "Mam ucznia, który rozumie wszystko, ale nie mówi - jak go uruchomić?",
            "Mam ucznia, który mówi dużo, ale robi wiele błędów - jak reagować?",
            "Mam ucznia początkującego, który boi się mówić - jak zacząć z nim pracę?",
            "Mam ucznia bardzo zaawansowanego - jak przygotować dla niego ciekawe zajęcia?",
            "Mam ucznia, który mówi bardzo szybko i chaotycznie - jak go uporządkować?",
            "Mam ucznia, który nie rozumie nagrań audio - jak mu pomóc?",
            "Mam ucznia, który nie rozumie tekstów czytanych - jak z nim pracować?",
            "Mam ucznia, który zna słowa, ale nie używa ich w rozmowie - co zrobić?",
            "Mam ucznia, który ciągle robi te same błędy - jak to zmienić?",
            "Mam ucznia, który chce dużo gramatyki - jak ją wprowadzać?",
            "Mam ucznia, który nie chce gramatyki - jak mimo to ją uczyć?",
            "„Ja to słowo znam, ale jak mam coś powiedzieć, to go nie pamiętam”. Jak zamieniać bierne słownictwo w aktywne?",
            "Mam ucznia, który nie chce robić powtórek - jak je wprowadzić?",
            "Mam ucznia, który zapomina struktury po kilku dniach - jak temu zapobiec?",
            "Mam ucznia, który rozumie teorię, ale nie stosuje jej w praktyce - jak to zmienić?",
        ],
    },
    {
        id: 5,
        name: "Przygotowanie lekcji i rozwój nauczyciela",
        range: "Lekcje 79–100",
        desc: "Jak planować zajęcia bez stresu i świadomie rozwijać warsztat.",
        topics: [
            "Mam lekcję i nie zdążyłam się do niej przygotować - jak ją poprowadzić?",
            "Mam lekcję bez podręcznika - jak ją zaplanować?",
            "Mam lekcję 1-1 i nie wiem, jaki materiał wybrać - co zrobić?",
            "Mam lekcję i nie znam branży ucznia - jak pracować?",
            "Mam ucznia biznesowego i nie wiem, jakie tematy wprowadzać - jak je wybrać?",
            "Mam ucznia, który potrzebuje języka do prezentacji - jak go przygotować?",
            "Mam ucznia, który potrzebuje języka do spotkań biznesowych - jak ćwiczyć takie sytuacje?",
            "Mam ucznia, który potrzebuje języka do maili - jak go tego nauczyć?",
            "Mam ucznia, który potrzebuje języka do rozmów telefonicznych - jak ćwiczyć takie rozmowy?",
            "Mam kurs firmowy i nie wiem, jak go dobrze zaplanować - jak to zrobić?",
            "Mam pierwszą lekcję z dorosłym uczniem - jak ją poprowadzić?",
            "Mam pierwszą lekcję z grupą - jak zbudować dobrą atmosferę?",
            "Mam ucznia, który pyta o rzeczy, których nie wiem - jak reagować?",
            "Mam uczniów starszych ode mnie - jak budować autorytet?",
            "Mam uczniów bardzo wymagających - jak prowadzić zajęcia?",
            "Mam ucznia, który oczekuje, że na każdej lekcji „zrobimy coś nowego”. Jak pokazać mu wartość powtórek?",
            "Mam uczniów, którzy przychodzą tylko „bo muszą” - jak ich zaangażować?",
            "Mam lekcję, która nie wyszła tak jak planowałam - jak z tego wyciągnąć wnioski?",
            "Mam wrażenie, że stoję w miejscu jako nauczyciel - jak się rozwijać?",
            "Mam dużo doświadczenia, ale chcę stworzyć własny styl nauczania - jak to zrobić?",
            "Mam ucznia, który wykonuje zadania, ale nie przenosi tego na rozmowę - jak przełożyć ćwiczenia na realne mówienie?",
            "Mam ucznia, który ciągle wraca do tych samych, bezpiecznych tematów - jak poszerzyć rozmowę, żeby wyszedł poza swoją „strefę komfortu”?",
        ],
    },
];

// globalny numer startowy każdego modułu
export const moduleStartNumber = (moduleIndex) =>
    MODULES.slice(0, moduleIndex).reduce((sum, m) => sum + m.topics.length, 1);
